import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function maxFilesValidator(maxFiles: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as FileList;
    if (files && files.length > maxFiles) {
      return { maxFiles: { required: maxFiles, actual: files.length } };
    }
    return null;
  };
}

export function maxSizeValidator(maxSize: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as FileList;
    if (files) {
      const totalSize = Array.from(files).reduce((acc, file) => acc + file.size, 0);
      if (totalSize > maxSize) {
        return { maxSize: { required: maxSize, actual: totalSize } };
      }
    }
    return null;
  };
}

export function fileUploadValidator(maxFiles: number, maxSize: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const files = control.value as FileList;
    if (files) {
      const maxFilesError = maxFilesValidator(maxFiles)(control);
      const maxSizeError = maxSizeValidator(maxSize)(control);
      return maxFilesError || maxSizeError ? { ...maxFilesError, ...maxSizeError } : null;
    }
    return null;
  };
}